module.exports = __webpack_public_path__ + "img/cow.b84733e4.png";